import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import { useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import useMediaQuery from '@mui/material/useMediaQuery'
import { type ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import type { TripData } from 'screens/TripDashboard/TripDashboard.types'
import CustomsStop from 'screens/TripDetails/StopsView/CustomsStop'
import PrimaryStop from 'screens/TripDetails/StopsView/PrimaryStop'
import type { StopsSequenceGroup } from 'screens/TripDetails/TripDetails.types'

interface StopGroupShipmentsProps {
  group: StopsSequenceGroup
  trip: TripData
  weblinkToken?: string
}

const StopGroupShipments = ({
  group,
  trip,
  weblinkToken,
}: StopGroupShipmentsProps): ReactNode => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const { t } = useTranslation()

  return (
    <Stack spacing={1} sx={{ flexGrow: 1 }}>
      {isMobile && (
        <Typography variant="p4" color="primary.main">
          {t('screens.cs.trip_details.shipments_count', { count: group.stopLegPairs.length })}
        </Typography>
      )}
      {group.stopLegPairs.map((stopLegPair) => (
        <Paper
          sx={{
            padding: 2,
          }}
          key={`${stopLegPair.stop.sequence}_${stopLegPair.stop.wayPointCid}`}
        >
          {(stopLegPair.stop.type === 'PUP' || stopLegPair.stop.type === 'DEL') && (
            <PrimaryStop
              key={stopLegPair.stop.wayPointCid}
              trip={trip}
              leg={stopLegPair.leg}
              stop={stopLegPair.stop}
              weblinkToken={weblinkToken}
            />
          )}
          {stopLegPair.stop.type === 'CUS' && (
            <CustomsStop
              key={stopLegPair.stop.wayPointCid}
              trip={trip}
              leg={stopLegPair.leg}
              stop={stopLegPair.stop}
              weblinkToken={weblinkToken}
            />
          )}
        </Paper>
      ))}
    </Stack>
  )
}

export default StopGroupShipments
